import { ISelectOption } from "lobbie";

// eslint-disable-next-line
export enum EGender {
    MALE = 1,
    FEMALE = 2,
    NON_BINARY = 3,
    TRANSGENDER_MALE = 4,
    TRANSGENDER_FEMALE = 5,
    OTHER = 6,
    NON_DISCLOSE = 7,
    UNKNOWN = 8,
}

// NOTE: FHIR Gender Identities - https://www.hl7.org/fhir/r4/codesystem-gender-identity.html
export const GENDER_NAMES = {
    [EGender.MALE]: "male",
    [EGender.FEMALE]: "female",
    [EGender.NON_BINARY]: "non-binary",
    [EGender.TRANSGENDER_MALE]: "transgender male",
    [EGender.TRANSGENDER_FEMALE]: "transgender female",
    [EGender.OTHER]: "other",
    [EGender.NON_DISCLOSE]: "does not wish to disclose",
    [EGender.UNKNOWN]: "unknown",
};

export const GENDER_OPTIONS = [
    { value: EGender.MALE, label: "male" },
    { value: EGender.FEMALE, label: "female" },
    { value: EGender.NON_BINARY, label: "non-binary" },
    { value: EGender.TRANSGENDER_MALE, label: "transgender male" },
    { value: EGender.TRANSGENDER_FEMALE, label: "transgender female" },
    { value: EGender.OTHER, label: "other" },
    { value: EGender.NON_DISCLOSE, label: "does not wish to disclose" },
    { value: EGender.UNKNOWN, label: "unknown" },
];

export const DEFAULT_GENDER_OPTION = {
    value: -1,
    label: "Select a Gender",
} as ISelectOption;
